import * as React from "react";
import {
    AppBar, Toolbar, Theme, Typography, IconButton, TextField,
    InputAdornment, Icon,
} from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { SearchIcon as SearchIconCustom } from "../../../assets/iconComponents/Icons";
import { format, isSameDay, add, sub } from "date-fns";
import { getDataFromStorage, setDataToStorage } from "../../../common/sessionStorageHelpers";

const persistName = "PCR";
const getData = (value = "") => getDataFromStorage(persistName, value);
const setData = (key: string, value: any) => setDataToStorage(persistName, key, value);

const useStylesSubHeader = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            width: "100%",
        },
        menuButton: {
            marginLeft: theme.spacing(1),
        },
        centerText: {
            color: "#FFF",
            fontSize: 18,
            fontWeight: 700,
            opacity: 0.36,
            textTransform: "none",
        },
        centerButton: {
            minWidth: 0,
            padding: "5px 15px",
        },
        arrowButton: {
            color: "#fff",
        },
        searchAndDownloadContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        whiteBtn: {
            color: "#FFF",
            opacity: 0.5,
            padding: 3,
        },
        searchBox: {
            color: "#FFF",
        },
        disabledBtn: {
            opacity: 0.5,
        },
    })
);

const SubHeader = ({ leftButtonClick, show, title = "All Customer",settext, otherProps }: any): JSX.Element => {
    const classes = useStylesSubHeader();
    const { onSearchTextChange, endDay, startDay, setEndDay, setStartDay, setDateDialog, showCSVModalAction, loading, currentStatus, searchKey } = otherProps;
    let tempStartDay, tempEndDay;
    const IsDateDisplay =(status:number)=>{
        if (status==1 || status==2 || status==5 || status==6)
            return false;
        else
            return true;
    }
    return (
        <div className={classes.root}>
            <AppBar position="static" style={{ backgroundColor: "#01224A" }}>
                <Toolbar variant="dense" style={{ justifyContent: "space-between" }}>
                    <span style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400 }}>
                            {title}
                        </Typography>
                        {show.hospitalSelectArrow && (
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={leftButtonClick}>
                            <KeyboardArrowDownIcon />
                        </IconButton>
                        )}
                    </span>
                    {IsDateDisplay(currentStatus) ? <span style={{ paddingLeft: 185 }}>
                        <IconButton
                            onClick={() =>
                                isSameDay(startDay, endDay)
                                ? ((tempStartDay = sub(startDay, { days: 1 })),
                                (tempEndDay = sub(endDay, { days: 1 })),
                                setStartDay(tempStartDay),
                                setEndDay(tempEndDay))
                                //setData("startDay", tempStartDay),
                                //setData("endDay", tempEndDay))
                                : null
                            }
                            disabled={isSameDay(startDay, endDay) ? false : true}
                            classes={{ disabled: classes.disabledBtn }}
                            style={{ paddingTop: 8 }}
                        >
                            <KeyboardArrowLeftIcon className={classes.arrowButton} />
                        </IconButton>
                        <span style={{ cursor: "pointer" }} onClick={() => setDateDialog("startDay")}>
                            {format(startDay, "dd LLL yyyy")} -{" "}
                        </span>
                        <span style={{ cursor: "pointer" }} onClick={() => setDateDialog("endDay")}>
                            {format(endDay, "dd LLL yyyy")}
                        </span>
                        <IconButton
                            onClick={() =>
                                isSameDay(startDay, endDay)
                                ? ((tempStartDay = add(startDay, { days: 1 })),
                                (tempEndDay = add(endDay, { days: 1 })),
                                setStartDay(tempStartDay),
                                setEndDay(tempEndDay))
                                //setData("startDay", tempStartDay),
                                //setData("endDay", tempEndDay))
                                : null
                            }
                            disabled={isSameDay(startDay, endDay) ? false : true}
                            classes={{ disabled: classes.disabledBtn }}
                            style={{ paddingTop: 8 }}
                        >
                            <KeyboardArrowRightIcon className={classes.arrowButton} />
                        </IconButton>
                    </span> :<span style={{ paddingLeft: 185 }}><Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400 }}>All Time</Typography></span>}
                    <span className={classes.searchAndDownloadContainer}>
                        {/* <div style={{ alignSelf: "flex-end", marginRight: 30 }} onClick={showCSVModalAction}>
                            {/* <CloudDownloadIcon style={{ width: 24, height: 24, cursor: "pointer" }} /> */}
                        {/*    <img style={{ width: 24, height: 22, cursor: "pointer"}} src={require('../../../assets/svgs/download-icon.png')} />
                        </div> */}
                        {!loading ? (
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth={false}
                            defaultValue={searchKey}
                            style={{ margin: 0 }}
                            inputRef={(input) => input?.focus()}
                            onChange={(e) => {onSearchTextChange(e.target.value);settext(e.target.value)}}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Icon>
                                            <SearchIconCustom />
                                        </Icon>
                                    </InputAdornment>
                                ),
                                style: { backgroundColor: "#1d4468", color: "#fff", borderRadius: 4 },
                            }}
                        />
                        ) : (
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth={false}
                            style={{ margin: 0 }}
                            disabled={loading}
                            // className={classes.searchBox}
                            onChange={(e) =>  {onSearchTextChange(e.target.value);settext(e.target.value)}}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Icon>
                                            <SearchIconCustom />
                                        </Icon>
                                    </InputAdornment>
                                ),
                                style: { backgroundColor: "#1d4468", color: "#fff", borderRadius: 4 },
                            }}
                        />
                        )}
                    </span>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default SubHeader;